<template>
  <div class="step-index" v-if="currentStepIndex > 0">
    <span> {{ currentStepIndex }}/{{ totalSteps }} </span>
  </div>
</template>

<script>
export default {
  computed: {
    outcomeType() {
      return this.$store.getters.outcomeType;
    },
    currentStepIndex() {
      if (this.outcomeType === "media") {
        return this.$store.getters.currentStepIndex + 1;
      } else {
        return this.$store.getters.currentStepIndex;
      }
    },
    totalSteps() {
      if (this.outcomeType === "media") {
        return this.$store.getters.totalSteps + 1;
      } else {
        return this.$store.getters.totalSteps;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.step-index {
  background: $c-primary;
  border-radius: 500px;
  width: 105px;
  height: 105px;
  color: $c-white;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 15px;

  @include media(">=tablet") {
    font-size: 40px;
    padding-bottom: 26px;
  }
}
</style>
